import React from 'react';

export default function SimpleBarChart({
  title,
  items,
  valueKey = 'count',
  labelKey = 'planSlug',
}: {
  title: string;
  items: Record<string, unknown>[];
  valueKey?: string;
  labelKey?: string;
}) {
  if (!items.length) return null;
  const max = Math.max(...items.map((i) => Number(i[valueKey] || 0)), 1);
  return (
    <section className="panel admin-billing-chart">
      <h2>{title}</h2>
      <div className="admin-billing-bars">
        {items.map((item, idx) => {
          const val = Number(item[valueKey] || 0);
          const label = String(item[labelKey] || item.planName || idx);
          const pct = Math.round((val / max) * 100);
          return (
            <div key={label} className="admin-billing-bar-row">
              <span className="admin-billing-bar-label">{label}</span>
              <div className="admin-billing-bar-track">
                <div className="admin-billing-bar-fill" style={{ width: `${pct}%` }} />
              </div>
              <span className="admin-billing-bar-value">{val}</span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
